import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import CommentInputComponent from './CommentInputComponent';

import { createPostComment } from '../actions';

import { scrollIntoView } from '../../../utils';

import { COMMUNITY_COMMENT_INPUT_ID } from '../constants';

import CommunityContext from '../context';

const CommentInputContainer = ({ postId, disabled }) => {
  const dispatch = useDispatch();
  const checkIfCommunityMember = useContext(CommunityContext);

  const [comment, setComment] = useState('');

  const onCommentSubmit = async () => {
    const isCommentCreated = await createPostComment(dispatch, postId, {
      text: comment,
    });
    isCommentCreated && setComment('');
    scrollIntoView(`${COMMUNITY_COMMENT_INPUT_ID}_${postId}`);
  };

  const onSetComment = (value) => {
    if (!checkIfCommunityMember()) return;
    setComment(value);
  };

  return (
    <CommentInputComponent
      postId={postId}
      comment={comment}
      onSetComment={onSetComment}
      onCommentSubmit={onCommentSubmit}
      disabled={disabled}
    />
  );
};

CommentInputContainer.propTypes = {
  postId: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CommentInputContainer;
